module.exports = __webpack_public_path__ + "static/media/elijah.fbe27880.jpg";